import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function UserIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M3.5 13c1.168-1.457 2.754-2.353 4.5-2.353s3.332.896 4.5 2.353m-1.8-7.353c0 1.462-1.209 2.647-2.7 2.647S5.3 7.11 5.3 5.647 6.509 3 8 3s2.7 1.185 2.7 2.647" /></svg>
  );
}

export default UserIcon;
